import { SentryFeatureTags, logException } from "@punchup/sentry";

import { Database } from "../supabase.types";
import { SupabaseClient } from "@supabase/supabase-js";
import { getUser } from "../supabase/supabase";

export async function isSuperAdmin(
  supabase: SupabaseClient<Database>
): Promise<boolean> {
  const user = await getUser(supabase);
  if (!user) {
    return false;
  }

  const { status, data, error } = await supabase
    .from("super_admins")
    .select("user_id")
    .eq("user_id", user.id)
    .maybeSingle();

  if (error) {
    logException(error, {
      level: "warning",
      extra: {
        data: `Error looking up super_admins for user ${user.id}`,
        user_id: user.id,
      },
      tags: {
        supabase: true,
      },
    });
  } else if (status === 200) {
    if (data) {
      return true;
    } else {
      return false;
    }
  }
  throw new Error(
    `Error looking up super_admins for user ${user.id} status ${status}`
  );
}
